// Central content for Fred's Home Technical Services
// NOTE: Photography images use Fred's own photos with an Unsplash fallback on error.

export const business = {
  name: "Fred's Home Technical Services",
  owner: "Fred Mustica",
  tagline: "Local, honest tech help — plus stunning photography, licensed drone work and hand-built FPV parts.",
  since: 2006,
  phone: "0418 308 977",
  phoneHref: "tel:0418308977",
  email: "mustica@gmail.com",
  emailHref: "mailto:mustica@gmail.com",
  area: "Within 1 hour of Cobram & Barooga",
  address: "5 Churr St, Cobram VIC 3644",
  mapUrl: "https://www.google.com/maps/place/Fred+Mustica+-+Home+Technical+Services",
  youtube: "http://www.youtube.com/c/MrFredMustica/videos",
  rating: "4.2",
  reviewCount: 9,
};

export const hours = [
  { day: "Monday", time: "9:00 AM – 4:00 PM", open: true },
  { day: "Tuesday", time: "9:00 AM – 4:00 PM", open: true },
  { day: "Wednesday", time: "9:00 AM – 4:00 PM", open: true },
  { day: "Thursday", time: "9:00 AM – 3:00 PM", open: true },
  { day: "Friday", time: "9:00 AM – 3:00 PM", open: true },
  { day: "Saturday", time: "Closed", open: false },
  { day: "Sunday", time: "Closed", open: false },
];

export const stats = [
  { value: 19, suffix: "+", label: "Years in Business" },
  { value: 1000, suffix: "+", label: "Happy Customers" },
  { value: 1, suffix: "hr", label: "Service Radius" },
  { value: 4.2, suffix: "★", label: "Google Rating", decimal: true },
];

export const services = [
  { n: "01", title: "Computer Servicing", desc: "Full diagnostics, tune-ups & repairs to get your PC or laptop running like new again.", icon: "Cpu" },
  { n: "02", title: "Virus Removal", desc: "Deep clean of malware, spyware and viruses — plus setup to keep them out for good.", icon: "ShieldCheck" },
  { n: "03", title: "Hardware Setup", desc: "New PC, printer, router, monitor? I'll set it all up and make sure everything just works.", icon: "MonitorSmartphone" },
  { n: "04", title: "Backup & Recovery", desc: "Protect your precious photos, documents and memories with reliable backup solutions.", icon: "HardDriveDownload" },
  { n: "05", title: "Mobile & Tablet Help", desc: "Setup, transfers, email, apps and friendly advice for phones and tablets.", icon: "Smartphone" },
  { n: "06", title: "Security DVR & Cameras", desc: "Home & business CCTV — supply, install and configure security camera systems.", icon: "Cctv" },
  { n: "07", title: "Hardware Sales", desc: "Quality computer parts and security equipment sourced at a fair local price.", icon: "ShoppingBag" },
  { n: "08", title: "Troubleshooting", desc: "Weird error? Slow internet? Printer won't print? If it's tech, I can probably fix it.", icon: "Wrench" },
];

export const scamTips = [
  { title: "Never trust unexpected 'tech support' calls", desc: "If someone rings claiming to be from Telstra, Microsoft, Windows or your bank saying your computer is infected — HANG UP. It's a scam." },
  { title: "Never give remote access to strangers", desc: "Do NOT let anyone you don't know log into your computer over the phone or internet. Ever." },
  { title: "Ignore pop-ups asking you to call support", desc: "Pop-ups saying 'Call Microsoft Support Now' are 100% fake. Try holding ALT + F4 to close them." },
  { title: "Never enter card details on suspicious sites", desc: "Fake antivirus pop-ups love to ask for payment. If you're not 100% sure — don't pay." },
];

export const avoidPrograms = [
  "Optimiser Pro", "Regclean", "Winoptimiser", "System Tweak", "Regcure",
  "Parentologic", "Uniblue", "Filecure", "Conduit", "Ask Toolbar",
  "Fake AV Payment Prompts", "Anything that sounds like the above",
];

export const testimonials = [
  { quote: "Fred saved all my grandkids' photos when my old laptop died. Honest, patient and doesn't talk down to you. Wouldn't call anyone else.", name: "Margaret W.", town: "Cobram" },
  { quote: "Set up our whole security camera system and made it dead easy to use on our phones. Great value and Fred always answers when we call.", name: "David & Sue", town: "Barooga" },
  { quote: "Cleaned up a nasty virus that another 'expert' couldn't fix. Explained everything in plain English. Bought a canvas print of his while I was there — stunning!", name: "Peter K.", town: "Numurkah" },
  { quote: "Local, reliable and a lovely person. Fred came out same day when our business PC crashed. Back up and running in under an hour.", name: "Lisa H.", town: "Yarrawonga" },
];

// Photography — Fred's real photos with Unsplash fallbacks
const FB = [
  "https://images.unsplash.com/photo-1546721435-666d5f9a5676?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1545350089-47b3d117a92c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1633587444979-3fe790b463ba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1567510534272-07e0f621b6d3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1582076197964-9892cebf31ed?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1581956713636-e37c70888100?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1597060330071-69c1ac998254?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1562772186-4567f0003a1b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
];

export const gallery = [
  { title: "Drone Aerial", price: true, src: "https://www.mustica.com.au/images/DJI_035.jpg", fb: FB[0] },
  { title: "Water Reflections", price: true, src: "https://www.mustica.com.au/images/2022-03-31%2014.07.55%20water.jpg", fb: FB[5] },
  { title: "Golden Morning", price: true, src: "https://www.mustica.com.au/images/20220707_065938.jpg", fb: FB[1] },
  { title: "Sunrise", price: true, src: "https://www.mustica.com.au/images/20230422_060031-01jpg.jpg", fb: FB[2] },
  { title: "Golden Hour", src: "https://www.mustica.com.au/images/20230428_180644-jpg.jpg", fb: FB[6] },
  { title: "Country Scene", src: "https://www.mustica.com.au/images/2022-06-26%2011.47.43.jpg", fb: FB[3] },
  { title: "Local Landscape", src: "https://www.mustica.com.au/images/20211114_111121.jpg", fb: FB[4] },
  { title: "Summer Skies", src: "https://www.mustica.com.au/images/20220102_104108jpg.jpg", fb: FB[7] },
  { title: "Rural Beauty", src: "https://www.mustica.com.au/images/20220315_122441.jpg", fb: FB[3] },
  { title: "Early Light", src: "https://www.mustica.com.au/images/20211122_060529jpg.jpg", fb: FB[2] },
  { title: "The Bridge", src: "https://www.mustica.com.au/images/Bridge.jpg", fb: FB[5] },
  { title: "Midday Frame", src: "https://www.mustica.com.au/images/20210706_120205-01.jpg", fb: FB[4] },
  { title: "Afternoon", src: "https://www.mustica.com.au/images/20210706_155310jpg.jpg", fb: FB[1] },
  { title: "Countryside", src: "https://www.mustica.com.au/images/20210705_150606-.jpg", fb: FB[3] },
  { title: "Landscape", src: "https://www.mustica.com.au/images/2022-03-15%2013.38.28%20.jpg", fb: FB[0] },
];

export const photographyHero = "https://images.unsplash.com/photo-1633587444979-3fe790b463ba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";
export const canvasPrice = 220;

// Drone
export const droneImages = {
  hero: "https://images.unsplash.com/photo-1506947411487-a56738267384?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  pilot: "https://images.unsplash.com/photo-1514598800938-f7125ea1aa1c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  sky: "https://images.unsplash.com/photo-1690395782424-81ae275080aa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  farm1: "https://images.unsplash.com/photo-1516822277566-bb38424a2b77?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  farm2: "https://images.unsplash.com/photo-1619719826894-89d6c4fd5739?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const droneServices = [
  { title: "Aerial Photography", desc: "Crisp, high-resolution stills from above — perfect for property, landscapes and keepsakes.", icon: "Camera" },
  { title: "Cinematic Video", desc: "Smooth 4K aerial footage with professional editing for a truly cinematic result.", icon: "Video" },
  { title: "Real Estate & Property", desc: "Showcase homes, acreage and businesses with striking bird's-eye views buyers love.", icon: "Home" },
  { title: "Agriculture & Farmland", desc: "Crop, paddock and property surveys to help you see the whole picture from above.", icon: "Sprout" },
  { title: "Events & Occasions", desc: "Capture the scale and atmosphere of events, gatherings and special days.", icon: "PartyPopper" },
  { title: "Inspections", desc: "Safe, close-up aerial inspection of roofs, solar, towers and hard-to-reach spots.", icon: "Search" },
];

// FPV Jack Point Covers — Fred's own product photos
export const fpvImages = {
  hero: "https://www.mustica.com.au/images/2019-08-04-11.09.18-1024x768.jpg",
  img1: "https://www.mustica.com.au/images/67641940_103580910995034_3920126232854790144_o-1024x841.jpg",
  img2: "https://www.mustica.com.au/images/83289843_168696551150136_3694789923266625536_n.jpg",
  img3: "https://www.mustica.com.au/images/jack%20blank.jpg",
  img4: "https://www.mustica.com.au/images/sale.jpg",
};

export const fpvGallery = [
  { src: "https://www.mustica.com.au/images/67641940_103580910995034_3920126232854790144_o-1024x841.jpg", alt: "FPV Jack Point cover" },
  { src: "https://www.mustica.com.au/images/83289843_168696551150136_3694789923266625536_n.jpg", alt: "FPV Jack Point detail" },
  { src: "https://www.mustica.com.au/images/jack%20blank.jpg", alt: "Jack Point blank" },
  { src: "https://www.mustica.com.au/images/sale.jpg", alt: "FPV Jack Point for sale" },
  { src: "https://www.mustica.com.au/images/sale%203.jpg", alt: "FPV Jack Point" },
  { src: "https://www.mustica.com.au/images/sale2.jpg", alt: "FPV Jack Point" },
  { src: "https://www.mustica.com.au/images/sale4.jpg", alt: "FPV Jack Point" },
];

export const fpvProduct = {
  name: "FPV Jack Point Covers",
  subtitle: "Hand-built jack point covers for Ford Performance Vehicles",
  price: 130,
  unit: "per pair delivered",
  shippingAU: "Delivered Australia-wide with tracking — no extra fees.",
  shippingNZ: "Also shipped to New Zealand at the appropriate postage cost — just ask.",
  blurb: "Hand-built, precision-fit jack point covers for FPV (Ford Performance Vehicles). A clean, factory-look finish that protects your jacking points and tidies up the underside of your pride and joy. Sold as a matched pair and assembled by Fred in Cobram.",
  features: [
    "Sold as a matched pair — ready to install",
    "Precision-made to fit FPV jacking points",
    "Durable, weather-resistant finish",
    "Factory-look styling — clean and subtle",
    "Hand-built to order in Cobram",
    "Aussie-made quality",
  ],
  models: ["FG", "FG X", "BA / BF", "Not sure — ask me"],
};
